import { Link } from "react-router-dom";

const CustButton = ({ text, path }) => {
  return <Link to={path} className="bg-cust-button text-decoration-none">{text}</Link>;
};

export default CustButton;
